const NAME = 'PENDO';
const CNameMapping = {
  [NAME]: NAME,
  Pendo: NAME,
  pendo: NAME,
};

export { NAME, CNameMapping };
